import pick from 'lodash.pick';

import {
  getMetaDescription as generateMetaDescription,
  canonicaliseUrl
} from '@seek/seek-jobs-seo';

const clean = object => pick(object, x => x);

export const GET_META_DESCRIPTION = 'GET_META_DESCRIPTION';
export const GET_CANONICAL_URLS = 'GET_CANONICAL_URLS';

const initialState = {
  metaDescription: null,
  canonicalUrl: null,
  alternateUrl: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_META_DESCRIPTION: {
      const metaDescription = action.payload;

      return {
        ...state,
        metaDescription
      };
    }

    case GET_CANONICAL_URLS: {
      const {
        canonical: canonicalUrl,
        alternate: alternateUrl
      } = action.payload;

      return {
        ...state,
        canonicalUrl,
        alternateUrl
      };
    }

    default:
      return state;
  }
}

export const getMetaDescription = ({ locale, path }) => (dispatch, getState) => {
  const {
    search: { query },
    results: { totalCount, location }
  } = getState();

  const metaDescription = generateMetaDescription(clean({
    locale,
    path,
    query,
    totalCount,
    location
  }));

  dispatch({
    type: GET_META_DESCRIPTION,
    payload: metaDescription
  });
};

export const getCanonicalUrls = ({ locale, path, query }) => (dispatch, getState) => {
  const { results: { location } } = getState();
  const canonicalisation = canonicaliseUrl({ locale, path, query, location });
  dispatch({
    type: GET_CANONICAL_URLS,
    payload: canonicalisation
  });
};



/** WEBPACK FOOTER **
 ** ./app/store/seo/seo.js
 **/